import { render } from "./ParcelExcelUpload.vue?vue&type=template&id=1f4f6585&scoped=true"
import script from "./ParcelExcelUpload.vue?vue&type=script&lang=js"
export * from "./ParcelExcelUpload.vue?vue&type=script&lang=js"

import "./ParcelExcelUpload.vue?vue&type=style&index=0&id=1f4f6585&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f4f6585"]])

export default __exports__